export const RENDERER_API_URL = 'https://favyt-backend.onrender.com/'; // Backend Address renderer
export const API_URL = 'https://hx-rails-mongo.onrender.com/'; // 'http://127.0.0.1:3000/';
